<template>
    <BreadCrumb PageTitle="Détail d'attribution" />
    <DetailAttribution/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import DetailAttribution from "../../components/Attribution/DetailAttribution.vue";
    //import DetailRetour from "../../components/Retour/DetailRetour.vue";

  
    export default defineComponent({
      name: "DetailAttributionPage",
      components: {
        BreadCrumb,
        DetailAttribution,
      },
    });
  </script>